import { Link } from 'react-router-dom';
import { useTranslate } from 'ra-core';
import { authProvider } from '../../../authProvider';
import { useQuery } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/admin/spinner';

type Props = {
  oobCode: string;
};

function EmailVerificationPage({ oobCode }: Props) {
  const t = useTranslate();
  const { isLoading: isVerifying, isSuccess: isEmailVerified } = useQuery({
    queryKey: ['verify-email', { oobCode }],
    queryFn: () => authProvider.verifyEmail(oobCode),
  });

  return (
    <>
      <div>
        <Link to="/">
          <img
            alt="logo"
            src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-white.png"
            style={{ height: 55, width: 'auto', margin: 'auto' }}
          />
        </Link>
      </div>
      {isVerifying ? (
        <div className="flex justify-center py-8">
          <Spinner size="large" />
        </div>
      ) : isEmailVerified ? (
        <div className="text-center flex flex-col gap-4">
          <h5 className="text-xl font-semibold">
            {t('auth.message.verified')}
          </h5>
          <Button asChild>
            <Link to="/login">{t('auth.button.login')}</Link>
          </Button>
        </div>
      ) : (
        <p className="text-center">{t('error.oops')}</p>
      )}
    </>
  );
}

export default EmailVerificationPage;
